import React, { useState, useEffect} from 'react';
import ImageButton from './imageButton';

const Rip = ({channel, server_host, uid, username, roomId, is_coaching_room=false, is_owner=false, is_coach=false}) => {

  const [isRipRunning, setIsRipRunning] = useState(false);
  const [isRipReady, setIsRipReady] = useState(false);
  const [isRestituting, setIsRestituting] = useState(false);
  const [ripDuration, setRipDuration] = useState(0);
  const [ripQuestion, setRipQuestion] = useState('');
  const [isRipMaster, setIsRipMaster] = useState(false);
  const [isPauseRunning, setIsPauseRunning] = useState(false);
  const [isFeedbackRunning, setIsFeedbackRunning] = useState(false);
  const [isBipSoundOn, setIsBipSoundOn] = useState(true);

    let protocol = process.env.REACT_APP_PROTOCOL
    if (protocol === undefined){
      protocol = "http"
    }

  const bipSound = new Audio(protocol + '://' + server_host + ':3050/sounds/sonar_bip.flac');
  bipSound.volume = 0.07; // Adjust the volume as desired
 

  function bip() {
      bipSound.play();
  }

  const handleInputChange = (e) => {
    setRipQuestion(e.target.value);
    if (e.target.value.length > 5) {
      setIsRipReady(true)
    } else {
      setIsRipReady(false)
    }
  };
  
  // to begin with, restitution time is 1/4 of introspection time
    
  
  useEffect(() => {
    channel.on('rip status', ripStatus => {
      if (roomId === ripStatus['room']) {
        setIsRestituting(ripStatus['restitution'])
        setIsRipRunning((ripStatus['duration'] > 0))
        const is_master = ripStatus['originator'] === uid
        if (! is_master || ripStatus['restitution']) {
          setRipQuestion(ripStatus['question'])
          setRipDuration(ripStatus['duration'])
        }
     }
    })

    channel.on('pause status', status => {
      if (roomId === status['room']) {
        setIsPauseRunning((status['duration'] > 0))
       }
    })

    channel.on('feedback status', status => {
      if (roomId === status['room']) {
        setIsFeedbackRunning((status['duration'] > 0))
       }
    })

  }, [isBipSoundOn]);


  
  const toggleBipSoundOn = () => {
    setIsBipSoundOn(true)
  };

  const toggleBipSoundOff = () => {
    setIsBipSoundOn(false)
  }



    useEffect(() => {
        let interval;
    
        if (isRipRunning && isRipMaster) {
          interval = setInterval(() => {
            const nduration = ripDuration - 1000
            setRipDuration(nduration);
            if (nduration <= 0) {
              setIsRipRunning(false)
            }
            channel.emit('rip running', 
              {
                'room' : roomId, 
                'question' : ripQuestion, 
                'duration' : nduration, 
                'restitution' : isRestituting,
                'originator' : uid,
                'username' : username
              })
          }, 1000);
        }
    
        return () => clearInterval(interval);
      
  }, [isRipRunning, roomId, ripDuration, channel, ripQuestion, isRestituting, isRipMaster]);
    


      const startTimer = () => {
        if (ripQuestion === '' ) {
          alert('Pour démarrer, une question doit être posée')
          return
        }
        if (ripDuration < 60000) {
          alert("Le temps d'introspection minimal est de soixante secondes")
          return
        }
        setIsRipRunning(true);
        setIsRipMaster(true)
        channel.emit('rip running', 
          {
            'room' : roomId, 
            'question' : ripQuestion, 
            'duration' : ripDuration, 
            'restitution' : isRestituting,
            'originator' : uid,
            'username' : username
          })
      };
    
      const addTimer = () => {
        if (isRipRunning) {
          return
        }
        setRipDuration(ripDuration + 60000);
      };

      const addTimer10 = () => {
        if (isRipRunning) {
          return
        }
        setRipDuration(ripDuration + 600000);
      };
    
      const subTimer = () => {
        if (isRipRunning) {
          return
        }
        const d = ripDuration - 60000; 
        if (d <= 0) {
          setIsRipRunning(false)
        }
        setRipDuration(Math.max(0, d))
      };

      const subTimer10 = () => {
        if (isRipRunning) {
          return
        }
        const d = ripDuration - 600000; 
        if (d <= 0) {
          setIsRipRunning(false)
          setIsRipReady(false)
          setRipQuestion('')
        }
        setRipDuration(Math.max(0, d))
      };
    
      const stopTimer = () => {
        if (isRipRunning) {
          return
        }
        setIsRipRunning(false);
      };
    
      const resetTimer = () => {
        if (isRipRunning) {
          return
        }
        setRipDuration(180000);
        setIsRipRunning(false);
      };
    

    const rtime = ripDuration / 1000

    if (! isPauseRunning && ! isFeedbackRunning && rtime > 0){
        const minutes = Math.floor(rtime  / 60);
        const seconds = rtime % 60;
    
        return (
            <div className='rip' title='Introspection' >
            {! isRipRunning && ! isRestituting ? (
              <div>
                {isRipReady && ripDuration > 59000 && is_coach && is_owner ? (
                  <ImageButton
                    url={`${protocol}://${server_host}:3050/images/play-circle.svg`} onClick={startTimer} title="C'est partrip !" size='small' 
                    color='lightgreen'/>
                ) : (' ')}
                { is_coach && is_owner ? (
                    <ImageButton
                    url={`${protocol}://${server_host}:3050/images/plus-circle.svg`}  title="+ 10'" size='small' 
                onClick={addTimer10} />) : ( ' ') }
                { is_coach && is_owner ? (
                  <ImageButton
                    url={`${protocol}://${server_host}:3050/images/plus.svg`}  title="+ 1'" size='small' 
                 onClick={addTimer}/> ) : (' ')}
                 { is_coach && is_owner ? (
                  <ImageButton
                    url={`${protocol}://${server_host}:3050/images/minus.svg`}  title="- 1'" size='small' 
                  onClick={subTimer}/> ) : (' ')}
                  { is_coach && is_owner ? (
                    <ImageButton
                    url={`${protocol}://${server_host}:3050/images/minus-circle.svg`}  title="- 10' ou annuler" size='small' 
                   onClick={subTimer10}/> ) : (' ')}
                   { is_coach && is_owner ? (
                    <textarea 
                    onChange={handleInputChange}
                    placeholder="La question ou les question de Rip, ici..."/>) : (' ') }
                  { ripDuration > 0 ? (
                        ' ' + minutes.toString().padStart(2, '0')) + ' min' : (' ')}                </div>
                  ) : ( '    ' +  ripQuestion + ' ....  ' )           
            }
            { ripDuration > 0 ? (
                  minutes.toString().padStart(2, '0')) : (' ')}:
            { ripDuration > 0 ? (
                  seconds.toString().padStart(2, '0')) : (' ')}
            {isBipSoundOn && ripDuration > 0 ? (
              bip()
              ) : (' ')}
            {isBipSoundOn ? (
              
              <ImageButton
                    url={`${protocol}://${server_host}:3050/images/volume-x.svg`} title="pas de bip" size='small' color = '#FFAAAA;'
                   onClick={toggleBipSoundOff}/> 
            )
            : (
              <ImageButton
              url={`${protocol}://${server_host}:3050/images/volume.svg`}  title="des bips" size='small'
             onClick={toggleBipSoundOn}/> 
            )
            }
          </div>
        )
    } else {
        return (
            <div className="rip" title="Introspection">
                { is_coach && is_owner && is_coaching_room && !isPauseRunning && !isFeedbackRunning ? (
                <ImageButton title="Introspection, le temps d'un RIP" color='#dfd046' size='small' 
                    url={`${protocol}://${server_host}:3050/images/cloud-snow.svg`}
                onClick={() => resetTimer(180000)}/>
                ) : ' ' }
            </div>
        )
    }
}

export default Rip;